export const enterKeyDirective = {
    inserted : function( element, binding, node ) {
        element.addEventListener( 'keypress', function( event ) {
            if( event.which === 13 ) {
                if( typeof binding.value === 'function' ) {
                    return binding.value( event );
                }
            }
            return false;
        });
    }
};

export const focusDirective = {
    inserted : function( element, binding, node ) {
        element.focus();
    }
};

